defineDs('DanskeSpil/Framework/PlayerAccountManagement/Scripts/Templates/Svg', [
  'Shared/Framework/Mithril/Scripts/Core/Mithril'
], function (m) {
  'use strict';
  /*
    Example Usage: Svg('arrow_big_down', { class: 'hi', height: 18, width: 18 });
  */
  return function svgTemplate(svgName, options) {

    var props = {
      class: 'sprite-symbol' + (options && options.modifiers ? options.modifiers.map(function (modifier) { return ' sprite-symbol--' + modifier; }) : ''),
      xmlns: 'http://www.w3.org/2000/svg',
      ...options
    };

    return m('svg', props, [
      m('use', {
        href: (props && props.href ? (props.href.substring(props.href.length - 1) === '#' ? props.href : (props.href + '#')) : '/Components/DanskeSpil/Framework/PlayerAccountManagement/Graphics/SpriteSheets/PamUiKit.svg#') + svgName
      })
    ]);
  };
});
